<div class="error-page">
  <div class="error-card">
    <a [routerLink]="['/']" class="logo-link">
      <img class="logo-image" src="content/images/logo.png" alt="Leanbyte Logo" />
    </a>

    @if (error404) {
      <div class="error-code error-code--404">404</div>
      <div class="error-label">
        <i class="pi pi-compass"></i>
        <span>{{ 'error.title' | translate }}</span>
      </div>
      <p class="error-message">{{ 'error.http.404' | translate }}</p>
    } @else if (error403) {
      <div class="error-code error-code--403">403</div>
      <div class="error-label error-label--danger">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ 'error.title' | translate }}</span>
      </div>
      <p class="error-message">{{ 'error.http.403' | translate }}</p>
    } @else {
      <div class="error-code error-code--generic">!</div>
      <div class="error-label error-label--danger">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ 'error.title' | translate }}</span>
      </div>
      @if (errorMessage) {
        <p class="error-message">{{ errorMessage }}</p>
      }
    }

    @if (errorJson) {
      <details class="error-details">
        <summary>Show technical details</summary>
        <pre class="error-json">{{ errorJson | json }}</pre>
      </details>
    }

    <div class="error-actions">
      <button pButton type="button" class="p-button-outlined p-button-secondary"
              (click)="goToPreviousPage()">
        <i class="pi pi-arrow-left"></i>
        <span>Go back</span>
      </button>
      <a pButton [routerLink]="['/']" class="p-button-primary">
        <i class="pi pi-home"></i>
        <span>Back to home</span>
      </a>
    </div>
  </div>
</div>
